(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aim-listicle1-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.aim-l1-info-accordion');
    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('[data-accordion-trigger]');
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          var contentId = trigger.getAttribute('aria-controls');
          var content = document.getElementById(contentId);
          if (!content) return;
          if (expanded) {
            trigger.setAttribute('aria-expanded', 'false');
            content.setAttribute('hidden', '');
          } else {
            trigger.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-listicle1-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* Scope each FAQ section independently so multiple FAQs on one page
       don't control each other's open/close state. */
    var sections = document.querySelectorAll('.aim-l1-faq[data-section-id]');

    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('.aim-l1-faq__trigger');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var contentId = this.getAttribute('aria-controls');
          var content = document.getElementById(contentId);

          /* Close all other items WITHIN THIS SECTION only */
          triggers.forEach(function(otherTrigger) {
            if (otherTrigger !== trigger) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              var otherId = otherTrigger.getAttribute('aria-controls');
              var otherContent = document.getElementById(otherId);
              if (otherContent) {
                otherContent.style.maxHeight = '0';
                otherContent.classList.remove('aim-l1-faq__content--open');
              }
            }
          });

          /* Toggle current */
          if (expanded) {
            this.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0';
            content.classList.remove('aim-l1-faq__content--open');
          } else {
            this.setAttribute('aria-expanded', 'true');
            /* Use scrollHeight but also set to 'none' after transition so
               dynamically-grown content (images loading, etc.) stays visible */
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.add('aim-l1-faq__content--open');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-listicle1-product-selector"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="aim-l1-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp-carousel-slides]');
      var dotsContainer = carousel.querySelector('[data-pdp-carousel-dots]');
      var prevBtn = carousel.querySelector('[data-pdp-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-pdp-carousel-next]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.aim-l1-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;
      var currentPdpSlide = 0;
      function goToPdpSlide(index) {
        currentPdpSlide = index;
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.aim-l1-pdp__carousel-dot');
          dots.forEach(function(d, i) { d.classList.toggle('aim-l1-pdp__carousel-dot--active', i === index); });
        }
      }
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'aim-l1-pdp__carousel-dot' + (index === 0 ? ' aim-l1-pdp__carousel-dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToPdpSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { goToPdpSlide((currentPdpSlide - 1 + totalSlides) % totalSlides); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToPdpSlide((currentPdpSlide + 1) % totalSlides); });
    });

    /* ============ Size Buttons ============ */
    var sizeButtons = document.querySelectorAll('.aim-l1-pdp__size-btn');
    var sizeIndexToQuantity = [1, 2, 3];

    /* FIX #6: Bind click handlers FIRST, then auto-click the default.
       Previously the auto-click fired before handlers were attached. */
    sizeButtons.forEach(function(btn, sizeIndex) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('aim-l1-pdp__size-btn--active'); });
        this.classList.add('aim-l1-pdp__size-btn--active');
        var targetQty = sizeIndexToQuantity[sizeIndex];
        if (targetQty == null) return;
        var targetCard = document.querySelector('.aim-l1-pdp__qty-card[data-line-item-quantity="' + targetQty + '"]');
        if (targetCard) targetCard.click();
      });
    });

    /* Auto-click the Liquid-selected default size AFTER handlers are bound */
    var defaultSizeBtn = document.querySelector('.aim-l1-pdp__size-btn--active');
    if (defaultSizeBtn) defaultSizeBtn.click();

    /* ============ Purchase type toggle ============ */
    var infoWrapper = document.getElementById('aim-l1-pdp-info');
    var toggleTrack = document.getElementById('aim-l1-purchase-toggle');
    var toggleSub = document.getElementById('aim-l1-toggle-sub');
    var toggleOtp = document.getElementById('aim-l1-toggle-otp');
    var sellingPlanInput = document.getElementById('aim-l1-selling-plan');
    var quantityInput = document.getElementById('aim-l1-line-quantity');

    function setPurchaseType(type) {
      if (!infoWrapper || !toggleTrack) return;
      infoWrapper.setAttribute('data-purchase-type', type);
      toggleTrack.setAttribute('data-active', type === 'subscription' ? 'sub' : 'otp');
      if (toggleSub && toggleOtp) {
        var subActive = type === 'subscription';
        toggleSub.classList.toggle('aim-l1-pdp__toggle-btn--active', subActive);
        toggleOtp.classList.toggle('aim-l1-pdp__toggle-btn--active', !subActive);
        toggleSub.setAttribute('aria-selected', subActive ? 'true' : 'false');
        toggleOtp.setAttribute('aria-selected', subActive ? 'false' : 'true');
      }
      /* FIX #5: Clear or restore the selling_plan hidden input */
      if (sellingPlanInput) {
        var defaultPlan = sellingPlanInput.getAttribute('data-default-selling-plan') || '';
        sellingPlanInput.value = (type === 'subscription') ? defaultPlan : '';
      }
      /* Swap price/meta/badge text on every qty card */
      var prefix = type === 'subscription' ? 'sub' : 'onetime';
      var cards = document.querySelectorAll('.aim-l1-pdp__qty-card');
      cards.forEach(function(card) {
        var salePrice = card.getAttribute('data-' + prefix + '-sale-price') || '';
        var comparePrice = card.getAttribute('data-' + prefix + '-compare-price') || '';
        var meta = card.getAttribute('data-' + prefix + '-meta') || '';
        var discountBadge = card.getAttribute('data-' + prefix + '-discount-badge') || '';
        var urgencyBadge = card.getAttribute('data-' + prefix + '-urgency-badge') || '';
        var saleEl = card.querySelector('[data-slot="sale-price"]');
        var compareEl = card.querySelector('[data-slot="compare-price"]');
        var metaEl = card.querySelector('[data-slot="meta"]');
        var discountEl = card.querySelector('[data-badge-slot="discount"]');
        var urgencyEl = card.querySelector('[data-badge-slot="urgency"]');
        if (saleEl) saleEl.textContent = salePrice;
        if (metaEl) metaEl.textContent = meta;
        if (compareEl) {
          compareEl.textContent = comparePrice;
          var compareWrap = compareEl.closest('.aim-l1-pdp__qty-compare');
          if (compareWrap) { if (comparePrice) compareWrap.removeAttribute('hidden'); else compareWrap.setAttribute('hidden', ''); }
        }
        if (discountEl) { discountEl.textContent = discountBadge; if (discountBadge) discountEl.removeAttribute('hidden'); else discountEl.setAttribute('hidden', ''); }
        if (urgencyEl) { urgencyEl.textContent = urgencyBadge; if (urgencyBadge) urgencyEl.removeAttribute('hidden'); else urgencyEl.setAttribute('hidden', ''); }
      });
    }

    if (toggleSub) toggleSub.addEventListener('click', function() { setPurchaseType('subscription'); });
    if (toggleOtp) toggleOtp.addEventListener('click', function() { setPurchaseType('onetime'); });

    /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.aim-l1-pdp__qty-card');
    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() {
        qtyCards.forEach(function(c) {
          c.classList.remove('aim-l1-pdp__qty-card--selected');
          var radio = c.querySelector('.aim-l1-pdp__radio-outer');
          if (radio) { radio.classList.remove('aim-l1-pdp__radio-outer--checked'); radio.innerHTML = ''; }
        });
        this.classList.add('aim-l1-pdp__qty-card--selected');
        var radio = this.querySelector('.aim-l1-pdp__radio-outer');
        if (radio) { radio.classList.add('aim-l1-pdp__radio-outer--checked'); radio.innerHTML = '<div class="aim-l1-pdp__radio-inner"></div>'; }
        /* FIX #4: Keep hidden quantity input in sync */
        if (quantityInput) {
          var q = parseInt(this.getAttribute('data-line-item-quantity'), 10);
          if (!isNaN(q) && q > 0) quantityInput.value = q;
        }
      });
    });

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('aim-l1-product-form');
    var atcButton = document.getElementById('aim-l1-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('aim-l1-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.aim-l1-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.aim-l1-pdp__atc-spinner') : null;
    var atcError = document.getElementById('aim-l1-atc-error');
    var variantInput = document.getElementById('aim-l1-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        var selectedCard = document.querySelector('.aim-l1-pdp__qty-card--selected');
        var lineQuantity = 1;
        if (selectedCard) { var q = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10); if (!isNaN(q) && q > 0) lineQuantity = q; }

        var purchaseType = infoWrapper ? infoWrapper.getAttribute('data-purchase-type') : 'subscription';
        var defaultSellingPlan = sellingPlanInput ? sellingPlanInput.getAttribute('data-default-selling-plan') : '';
        var variantId = variantInput ? variantInput.value : '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingSubPct = parseInt(infoWrapper ? infoWrapper.getAttribute('data-kaching-sub-discount') : '15', 10) || 15;
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : '',
          5: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-5') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        var sellingPlanInt = parseInt(defaultSellingPlan, 10);
        if (isNaN(sellingPlanInt)) sellingPlanInt = 0;

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var isSub = (purchaseType === 'subscription');
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        /* FIX #1: var payload - no longer leaks to global scope */
        var payload = { items: [] };

        /* Gifts first */
        if (shippingVariant && giftShippingId) payload.items.push(buildGiftItem(shippingVariant, giftShippingId, isSub));
        if (ebookVariant && giftEbookId && (lineQuantity === 3 || lineQuantity === 5)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (mysteryVariant && giftMysteryId && lineQuantity === 5) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* FIX #3: Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.aim-l1-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var mainKachingMeta = { deal: kachingDeal, main: true, id: bundleInstanceId, bid: mainBid };
        if (isSub && sellingPlanInt) { mainKachingMeta.sellingPlan = { id: sellingPlanInt, priceAdjustment: { type: 'percentage', value: kachingSubPct } }; }
        var mainItem = { id: variantId, quantity: lineQuantity, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        if (isSub && sellingPlanInt) mainItem.selling_plan = sellingPlanInt;
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          if (atcLabel) atcLabel.textContent = 'Redirecting...';
          window.location.assign('/checkout');
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-listicle1-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('[id^="aim-l1-reviews-"]');

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-reviews-track]');
      var prevBtn = carousel.querySelector('[data-reviews-prev]');
      var nextBtn = carousel.querySelector('[data-reviews-next]');
      var dotsContainer = carousel.parentElement.querySelector('[data-reviews-dots]');
      if (!track) return;

      var slides = track.querySelectorAll('.aim-l1-reviews__slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;

      function getSlidesPerView() {
        return window.innerWidth >= 1024 ? 2 : 1;
      }

      var currentIndex = 0;

      function totalPages() {
        var per = getSlidesPerView();
        return Math.max(1, totalSlides - per + 1);
      }

      function clampIndex(idx) {
        var max = totalPages() - 1;
        if (idx < 0) return max;
        if (idx > max) return 0;
        return idx;
      }

      function goToIndex(idx) {
        currentIndex = clampIndex(idx);
        var targetSlide = slides[currentIndex];
        if (!targetSlide) return;
        track.style.transform = 'translateX(-' + targetSlide.offsetLeft + 'px)';
        updateDots();
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        var pages = totalPages();
        if (pages <= 1) return;
        for (var i = 0; i < pages; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'aim-l1-reviews__dot' + (index === currentIndex ? ' aim-l1-reviews__dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToIndex(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }

      function updateDots() {
        if (!dotsContainer) return;
        var dots = dotsContainer.querySelectorAll('.aim-l1-reviews__dot');
        dots.forEach(function(d, i) {
          d.classList.toggle('aim-l1-reviews__dot--active', i === currentIndex);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() { goToIndex(currentIndex - 1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() { goToIndex(currentIndex + 1); });
      }

      var resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          currentIndex = clampIndex(currentIndex);
          buildDots();
          goToIndex(currentIndex);
        }, 150);
      });

      buildDots();
      goToIndex(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gwp-aim-product-selector"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var psCarousels = document.querySelectorAll('[id^="gwp-ps-carousel-"]');
    psCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-ps-carousel-slides]');
      var dotsContainer = carousel.querySelector('[data-ps-carousel-dots]');
      var prevBtn = carousel.querySelector('[data-ps-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-ps-carousel-next]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.gwp-ps__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;
      var currentSlide = 0;
      function goToSlide(index) {
        currentSlide = index;
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.gwp-ps__carousel-dot');
          dots.forEach(function(d, i) { d.classList.toggle('gwp-ps__carousel-dot--active', i === index); });
        }
      }
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'gwp-ps__carousel-dot' + (index === 0 ? ' gwp-ps__carousel-dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide((currentSlide - 1 + totalSlides) % totalSlides); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide((currentSlide + 1) % totalSlides); });

      /* touch/swipe */
      var startX = 0;
      carousel.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
      carousel.addEventListener('touchend', function(e){
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide((currentSlide + 1) % totalSlides);
          else goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }
      }, {passive:true});
    });

    /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.gwp-ps__qty-card');
    var atcButton = document.getElementById('gwp-ps-add-to-cart');
    var atcPriceEl = atcButton ? atcButton.querySelector('[data-atc-price]') : null;
    var selectedCheckoutUrl = '';

    function selectCard(card) {
      if (!card) return;
      qtyCards.forEach(function(c) {
        c.classList.remove('gwp-ps__qty-card--selected');
        var radio = c.querySelector('.gwp-ps__radio-outer');
        if (radio) { radio.classList.remove('gwp-ps__radio-outer--checked'); radio.innerHTML = ''; }
      });
      card.classList.add('gwp-ps__qty-card--selected');
      var radio = card.querySelector('.gwp-ps__radio-outer');
      if (radio) { radio.classList.add('gwp-ps__radio-outer--checked'); radio.innerHTML = '<div class="gwp-ps__radio-inner"></div>'; }
      selectedCheckoutUrl = card.getAttribute('data-checkout-url') || '';
      var priceEl = card.querySelector('.gwp-ps__qty-price');
      if (atcPriceEl && priceEl) atcPriceEl.textContent = '| ' + priceEl.textContent.trim();
    }

    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() { selectCard(this); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(this); }
      });
    });

    /* ============ Size buttons -> update supply/cost meta on every tier ============ */
    var sizeButtons = document.querySelectorAll('.gwp-ps__size-btn');

    function applySizeMeta(btn) {
      if (!btn) return;
      qtyCards.forEach(function(card, i) {
        var metaEl = card.querySelector('[data-qty-meta]');
        if (!metaEl) return;
        var val = btn.getAttribute('data-meta-' + (i + 1));
        if (val && val.trim() !== '') {
          metaEl.textContent = val;
        } else {
          metaEl.textContent = metaEl.getAttribute('data-default-meta') || '';
        }
      });
    }

    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('gwp-ps__size-btn--active'); });
        this.classList.add('gwp-ps__size-btn--active');
        applySizeMeta(this);
      });
    });

    /* Initialise from the Liquid-selected default card */
    var initialCard = document.querySelector('.gwp-ps__qty-card--selected') || qtyCards[0];
    if (initialCard) selectCard(initialCard);

    /* Apply the default size's meta on load */
    var initialSize = document.querySelector('.gwp-ps__size-btn--active') || sizeButtons[0];
    if (initialSize) applySizeMeta(initialSize);

    /* ============ Checkout redirect ============ */
    var psRoot = document.querySelector('.gwp-ps');
    var atcError = document.getElementById('gwp-ps-atc-error');
    function showAtcError(msg){ if(atcError){ atcError.textContent = msg; atcError.removeAttribute('hidden'); } }
    function clearAtcError(){ if(atcError){ atcError.setAttribute('hidden',''); atcError.textContent=''; } }

    function buildCheckoutUrl(baseUrl) {
      if (!psRoot) return baseUrl;
      var code = (psRoot.getAttribute('data-discount-code') || '').trim();
      if (!code) return baseUrl;
      var style = psRoot.getAttribute('data-discount-param') || 'query';
      if (style === 'path') {
        return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(baseUrl);
      }
      var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
      return baseUrl + sep + 'discount=' + encodeURIComponent(code);
    }

    if (atcButton) {
      atcButton.addEventListener('click', function() {
        clearAtcError();
        if (!selectedCheckoutUrl) {
          showAtcError('Please choose a package.');
          return;
        }
        var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
        var labelEl = atcButton.querySelector('.gwp-ps__atc-label');
        var spinnerEl = atcButton.querySelector('.gwp-ps__atc-spinner');
        atcButton.setAttribute('aria-busy', 'true');
        if (labelEl) labelEl.textContent = 'Redirecting...';
        if (atcPriceEl) atcPriceEl.textContent = '';
        if (spinnerEl) spinnerEl.removeAttribute('hidden');
        window.location.assign(buildCheckoutUrl(selectedCheckoutUrl));
      });
    }

    /* bfcache restore */
    window.addEventListener('pageshow', function(event) {
      if (event.persisted && atcButton) {
        atcButton.setAttribute('aria-busy', 'false');
        var labelEl = atcButton.querySelector('.gwp-ps__atc-label');
        var spinnerEl = atcButton.querySelector('.gwp-ps__atc-spinner');
        if (labelEl) labelEl.textContent = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
        if (spinnerEl) spinnerEl.setAttribute('hidden', '');
        var sel = document.querySelector('.gwp-ps__qty-card--selected');
        if (sel && atcPriceEl) {
          var p = sel.querySelector('.gwp-ps__qty-price');
          if (p) atcPriceEl.textContent = '| ' + p.textContent.trim();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gwp-product-selector"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var psCarousels = document.querySelectorAll('[id^="gwp-ps-carousel-"]');
    psCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-ps-carousel-slides]');
      var dotsContainer = carousel.querySelector('[data-ps-carousel-dots]');
      var prevBtn = carousel.querySelector('[data-ps-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-ps-carousel-next]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.gwp-ps__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;
      var currentSlide = 0;
      function goToSlide(index) {
        currentSlide = index;
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.gwp-ps__carousel-dot');
          dots.forEach(function(d, i) { d.classList.toggle('gwp-ps__carousel-dot--active', i === index); });
        }
      }
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'gwp-ps__carousel-dot' + (index === 0 ? ' gwp-ps__carousel-dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide((currentSlide - 1 + totalSlides) % totalSlides); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide((currentSlide + 1) % totalSlides); });

      /* touch/swipe */
      var startX = 0;
      carousel.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
      carousel.addEventListener('touchend', function(e){
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide((currentSlide + 1) % totalSlides);
          else goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }
      }, {passive:true});
    });

    /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.gwp-ps__qty-card');
    var atcButton = document.getElementById('gwp-ps-add-to-cart');
    var atcPriceEl = atcButton ? atcButton.querySelector('[data-atc-price]') : null;
    var selectedCheckoutUrl = '';

    function selectCard(card) {
      if (!card) return;
      qtyCards.forEach(function(c) {
        c.classList.remove('gwp-ps__qty-card--selected');
        var radio = c.querySelector('.gwp-ps__radio-outer');
        if (radio) { radio.classList.remove('gwp-ps__radio-outer--checked'); radio.innerHTML = ''; }
      });
      card.classList.add('gwp-ps__qty-card--selected');
      var radio = card.querySelector('.gwp-ps__radio-outer');
      if (radio) { radio.classList.add('gwp-ps__radio-outer--checked'); radio.innerHTML = '<div class="gwp-ps__radio-inner"></div>'; }
      selectedCheckoutUrl = card.getAttribute('data-checkout-url') || '';
      /* mirror the selected tier price into the ATC button */
      var priceEl = card.querySelector('.gwp-ps__qty-price');
      if (atcPriceEl && priceEl) atcPriceEl.textContent = '| ' + priceEl.textContent.trim();
    }

    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() { selectCard(this); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(this); }
      });
    });

    /* ============ Size buttons -> update supply/cost meta on every tier ============ */
    var sizeButtons = document.querySelectorAll('.gwp-ps__size-btn');

    function applySizeMeta(btn) {
      if (!btn) return;
      /* For each quantity card (by its index), set the meta text this size defines.
         data-meta-1 maps to the 1st card, data-meta-2 to the 2nd, etc. */
      qtyCards.forEach(function(card, i) {
        var metaEl = card.querySelector('[data-qty-meta]');
        if (!metaEl) return;
        var val = btn.getAttribute('data-meta-' + (i + 1));
        if (val && val.trim() !== '') {
          metaEl.textContent = val;
        } else {
          /* fall back to the card's own default meta if this size left it blank */
          metaEl.textContent = metaEl.getAttribute('data-default-meta') || '';
        }
      });
    }

    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('gwp-ps__size-btn--active'); });
        this.classList.add('gwp-ps__size-btn--active');
        applySizeMeta(this);
      });
    });

    /* Initialise from the Liquid-selected default card */
    var initialCard = document.querySelector('.gwp-ps__qty-card--selected') || qtyCards[0];
    if (initialCard) selectCard(initialCard);

    /* Apply the default size's meta on load */
    var initialSize = document.querySelector('.gwp-ps__size-btn--active') || sizeButtons[0];
    if (initialSize) applySizeMeta(initialSize);

    /* ============ Checkout redirect ============ */
    var psRoot = document.querySelector('.gwp-ps');
    var atcError = document.getElementById('gwp-ps-atc-error');
    function showAtcError(msg){ if(atcError){ atcError.textContent = msg; atcError.removeAttribute('hidden'); } }
    function clearAtcError(){ if(atcError){ atcError.setAttribute('hidden',''); atcError.textContent=''; } }

    /* Build the final checkout URL, attaching a discount code if configured. */
    function buildCheckoutUrl(baseUrl) {
      if (!psRoot) return baseUrl;
      var code = (psRoot.getAttribute('data-discount-code') || '').trim();
      if (!code) return baseUrl;
      var style = psRoot.getAttribute('data-discount-param') || 'query';
      if (style === 'path') {
        /* /discount/CODE?redirect=<url-encoded checkout path> */
        return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(baseUrl);
      }
      /* default: query param. Respect any existing ? already in the URL. */
      var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
      return baseUrl + sep + 'discount=' + encodeURIComponent(code);
    }

    if (atcButton) {
      atcButton.addEventListener('click', function() {
        clearAtcError();
        if (!selectedCheckoutUrl) {
          showAtcError('Please choose a package.');
          return;
        }
        var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
        var labelEl = atcButton.querySelector('.gwp-ps__atc-label');
        var spinnerEl = atcButton.querySelector('.gwp-ps__atc-spinner');
        atcButton.setAttribute('aria-busy', 'true');
        if (labelEl) labelEl.textContent = 'Redirecting...';
        if (atcPriceEl) atcPriceEl.textContent = '';
        if (spinnerEl) spinnerEl.removeAttribute('hidden');
        window.location.assign(buildCheckoutUrl(selectedCheckoutUrl));
      });
    }

    /* bfcache restore */
    window.addEventListener('pageshow', function(event) {
      if (event.persisted && atcButton) {
        atcButton.setAttribute('aria-busy', 'false');
        var labelEl = atcButton.querySelector('.gwp-ps__atc-label');
        var spinnerEl = atcButton.querySelector('.gwp-ps__atc-spinner');
        if (labelEl) labelEl.textContent = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
        if (spinnerEl) spinnerEl.setAttribute('hidden', '');
        var sel = document.querySelector('.gwp-ps__qty-card--selected');
        if (sel && atcPriceEl) {
          var p = sel.querySelector('.gwp-ps__qty-price');
          if (p) atcPriceEl.textContent = '| ' + p.textContent.trim();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
